import StorageShim from 'node-storage-shim';

let storage;

if (process.browser) {
    storage = sessionStorage;
} else {
    storage = new StorageShim();
}

export default storage;